import React from "react";
import { Link } from "react-router-dom";

// Renders a real <a> for absolute http(s) URLs (e.g. external subdomains),
// and a react-router <Link> for internal paths. Preserves all props.
export const SmartLink = ({ to, children, ...rest }) => {
  const isExternal = typeof to === "string" && /^https?:\/\//i.test(to);
  if (isExternal) {
    return (
      <a href={to} target="_blank" rel="noopener noreferrer" {...rest}>
        {children}
      </a>
    );
  }
  return (
    <Link to={to} {...rest}>
      {children}
    </Link>
  );
};

export default SmartLink;
